import { Alert, AlertProps } from "@mui/material";
import clsx from "clsx";
import React from "react";

interface ISystemAlertProps extends AlertProps { }

export const SystemAlert: React.FC<ISystemAlertProps> = (props) => {
    const {
        severity = 'info',
        className = '',
        ...restOfProps
    } = props

    return (
        <Alert
            className={clsx(
                // "border-x-4 py-2 text-base! font-semibold!",
                className
            )}
            severity={severity}
            {...restOfProps}
        />
    )
}
